import {Component} from "./Component";
import {hasParent} from "../util/dom";
import {createElement} from "../util/html";
import {WavePageTransition} from "../WavePageTransition";
import gsap from "gsap";
import {filterEventSelector} from "../util/event";

export class SiteHeader extends Component {

    static name = "site-header";

    // opened = false;

    get opened() {
        return document.body.classList.contains("--site-header-opened") ||
            document.body.classList.contains("--site-header-opening");
    }

    constructor(el) {
        super(el);


        this.$trigger = el.querySelector(".site-header__menu-trigger");
        this.$nav = this.querySelector(".site-header__nav");

        this.$pageTransitionOverlay = createElement(`<div class="site-header__wave-transition">
            <canvas />
        </div>`);

        this.pageTransition = new WavePageTransition(this.$pageTransitionOverlay, {
            duration: 0.8,
        });
        this.$nav.appendChild(this.$pageTransitionOverlay);

        // Hide menu when a link is clicked
        this.addEventListener(this.el, "click", filterEventSelector("a", (e) => {
            this.hide();
        }));

        this.addEventListener(this.$trigger, "click", this.onClickTrigger.bind(this));

        this.addEventListener(document.body, "click", this.onClickBody.bind(this));

        // Disable Ajax Navigation for language nav to trigger full page reload
        this.addEventListener(Array.from(document.querySelectorAll(".language-menu a")), "click", (e) => e.stopPropagation());
    }


    /**
     * OnClick callback for trigger
     * @param {MouseEvent} e
     */
    onClickTrigger(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log("onClickTrigger", this.opened);
        this.toggle();

    }

    /**
     * @param {MouseEvent} e
     */
    onClickBody(e) {
        if (!this.opened) return;

        // Return if click is inside this.el
        if (hasParent(e.target, this.$nav)) return;

        this.hide();
    }

    show() {
        if (this.opened) return;
        // this.opened = true;

        document.body.classList.add("--site-header-opening");
        this.pageTransition.color = getComputedStyle(document.body).getPropertyValue("--primary-background");
        this.pageTransition.show(-1).then(() => {
            document.body.classList.remove("--site-header-opening");
            document.body.classList.add("--site-header-opened");

            gsap.to(this.$nav.children, {
                opacity: 1,
                stagger: .1,
                duration: .2,
                ease: "power4.inOut"
            });
        });
    }

    hide() {
        if (!this.opened) return;
        // this.opened = false;
        document.body.classList.add("--site-header-closing");

        gsap.to(this.$nav.children, {
            opacity: 0,
            duration: .15,
            ease: "power2.inOut",
            onComplete: () => {
                this.pageTransition.hide(-1).then(() => {
                    document.body.classList.remove("--site-header-closing");
                    document.body.classList.remove("--site-header-opened");
                });
            }
        });

    }

    toggle() {
        if (document.body.classList.contains("--site-header-opened")) this.hide();
        else this.show();
    }



}
